module.exports = __webpack_public_path__ + "images/maximise455569f5cd646b67096702f40a8e5d5a.svg";